import React from 'react';
import { loadComponent } from '@moka-fe/mage-micro-app';
import { Loading } from 'sugar-design';

import { Application, Comment, User } from './type';

const CommentPC = React.lazy(() => loadComponent('candidate-comment.PC'));

interface CandidateCommentProps {
  application: Application;
  comments: Comment[];
  managers: User[];
  orgId: string;
}

const CandidateComment: React.FC<CandidateCommentProps> = (props) => {
  const { application, comments, managers, orgId } = props;

  return (
    <React.Suspense fallback={<Loading />}>
      <CommentPC
        source="headhunter"
        apiStrategy="headhunter"
        configuration={{
          disableEditComment: true,
          disableEditReply: true,
          disableDeleteComment: true,
          disableDeleteReply: true,
          isHeadhunter: true,
          useCustomUsers: true,
          enableAtUser: true,
          allUsers: managers,
          orgId: orgId,
          disableRoleFilter: true,
        }}
        commentId="headhunter"
        comments={{ currentApplicationComments: comments }}
        application={application}
      />
    </React.Suspense>
  );
};

export default CandidateComment;
